interface NoticeProps {
  tone?: 'info' | 'success' | 'warning' | 'error';
  children: React.ReactNode;
  role?: 'status' | 'alert';
}

export function Notice({ tone = 'info', children, role = 'status' }: NoticeProps) {
  return <div className={`notice ${tone}`} role={role}>{children}</div>;
}

